import React from 'react'
import PropTypes from 'prop-types'
import ZeroKmFlag from '@/modern/components/Stamps/ZeroKm'
import { Price, InfoArea, InfoAreaColumn, Card } from '@/modern/components/Card'
import ImageCard from '../../Card/ImageCard'
import {
  Item,
  ZeroStripes,
  Informations,
  AlignHorizontalInfoAreaStamp,
  Bullet,
  Ellipse,
} from './style'
import { Text, Link, LinkWithGrow } from '../style'

const VehicleDetailsHorizontal = props => {
  const { name, version, price, year, href = '#', image, experience } = props
  const linkProps = { rel: 'nofollow', target: '_blank', href }

  return (
    <Card
      isHorizontal
      background="linear-gradient(180deg, #FFFFFF 50%, #ECEDF2 100%);"
      shadow="0px 1px 2px rgba(46, 45, 55, 0.12);"
    >
      <LinkWithGrow {...linkProps}>
        <ImageCard isHorizontal>
          <img src={image} alt="zero" />
        </ImageCard>
      </LinkWithGrow>

      <InfoArea isHorizontal>
        <InfoAreaColumn grow={1} border="none">
          <Link {...linkProps}>
            <Informations>
              <Item>
                <Text size={20} color="#2E2D37" uppercase>
                  {name}
                </Text>
                <Text size={16} uppercase>
                  {version}
                </Text>
              </Item>

              <Item display="flex" margin="35px 0px 0px">
                <Text size={12} color="#696977" margin="0 12px">
                  <Bullet>
                    <Ellipse />
                  </Bullet>
                  {`2021/${year}`}
                </Text>

                <Text size={12} color="#696977" margin="0 12px">
                  <Bullet>
                    <Ellipse />
                  </Bullet>
                  0km
                </Text>
              </Item>
            </Informations>
          </Link>
        </InfoAreaColumn>
        <InfoAreaColumn border="none">
          <Link {...linkProps}>
            <Item>
              <AlignHorizontalInfoAreaStamp>
                <ZeroKmFlag />
              </AlignHorizontalInfoAreaStamp>
              {experience === 'PRICE' && (
                <Item>
                  <Text size={8}>preço sugerido</Text>
                  <Price isHorizontal value={`00, ${price}`} />
                </Item>
              )}
            </Item>
            <ZeroStripes />
          </Link>
        </InfoAreaColumn>
      </InfoArea>
    </Card>
  )
}

VehicleDetailsHorizontal.defaultProps = {
  name: null,
  version: null,
  price: null,
  year: null,
  href: '#',
  experience: null,
  image: null,
}

VehicleDetailsHorizontal.propTypes = {
  name: PropTypes.string,
  version: PropTypes.string,
  price: PropTypes.string,
  year: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.string,
  experience: PropTypes.string,
}

export default VehicleDetailsHorizontal
